import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('stockItemActivity', 'stockItemActivities');

const customActions = {
  async LOAD_stockItemActivities({ rootGetters, commit }, id) {
    const data = await odata.o(rootGetters)
      .get('stockItemActivities')
      .query({
        $filter: `stockItemId eq ${id} AND IsDeleted eq false`,
      });
    commit('SET_stockItem', data);
    return data;
  },
};

export default { ...actions, ...customActions };
